import CreditCardApplication from 'components/Content/CreditCards/CreditCardApplication/CreditCardApplication';
import { withCreditCardApplicationProps } from 'viewModel/content/creditCards/creditCardApplication/withCreditCardApplicationProps';

export default withCreditCardApplicationProps(CreditCardApplication);
